import { useUserProfile } from 'components/settings/userProfileContext';
import { collection, addDoc } from 'firebase/firestore';
import { db, useAuthState } from 'firebaseStore';

import { Commit, Change, Base, COMMIT_COLLECTION_NAME, commitCoverter, CommitAction } from 'models';

interface commitChangesInteface<T extends Base> {
    target: T;
    changes: Change[];
    languageIndexId?: string | null;
    action: CommitAction;
    message: string;
}
export const useCommitChanges = <T extends Base>(): ((
    _: commitChangesInteface<T>
) => Promise<any>) => {
    const [me] = useUserProfile();
    const [, , tenant] = useAuthState();
    if (!me) {
        return () => Promise.reject();
    }
    const makeNewCommit = <T extends Base>({
        target,
        changes,
        languageIndexId,
        action,
        message,
    }: commitChangesInteface<T>) => {
        console.log('useCommitChanges languageIndexId', languageIndexId);
        return new Commit({
            tenantId: tenant,
            typeIndex: `${tenant}_${target.__type}`,
            createdBy: me?.email,
            targetIndexId: target.indexId(),
            changes,
            action,
            message,
            languageIndexId: languageIndexId || null,
        });
    };
    const collectionRef = collection(db, COMMIT_COLLECTION_NAME).withConverter(commitCoverter);
    const makeCommit = <T extends Base>({
        target,
        changes,
        action,
        message,
        languageIndexId,
    }: commitChangesInteface<T>) => {
        const commit = makeNewCommit({ target, changes, action, message, languageIndexId });
        console.log('useCommitChanges commit', commit);
        return addDoc(collectionRef, commit).then((newId) => {
            console.log('useCommitChanges newId', newId);
            return Promise.resolve(newId);
        });
    };
    return makeCommit;
};

interface commitInteface<T extends Base> {
    current: T;
    previous?: T;
    action: CommitAction;
    languageIndexId?: string;
    message: string;
}
export const useCommit = <T extends Base>(): ((_: commitInteface<T>) => Promise<any>) => {
    const commitChanges = useCommitChanges<T>();
    const commit = ({ current, previous, languageIndexId, action, message }: commitInteface<T>) => {
        const changes = current.diff(previous);
        return commitChanges({ target: current, changes, languageIndexId, action, message });
    };
    return commit;
};
